import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function canvasListPath(preview, search = '') {
  const source = new URLSearchParams(search);
  const params = new URLSearchParams();
  // Creation/handoff parameters should not reopen a dialog on the way back.
  for (const key of ['q', 'sort']) {
    if (source.get(key)) params.set(key, source.get(key));
  }
  const query = params.toString();
  return `${preview ? '/prototype/vnext/canvas' : '/canvas'}${query ? `?${query}` : ''}`;
}

export function useReturnToCanvasList(preview, canvasId) {
  const navigate = useNavigate();
  const { state } = useLocation();
  return useCallback(() => {
    const root = canvasListPath(preview);
    const saved = state?.canvasListReturn;
    const fromList = saved && (saved.path === root || saved.path?.startsWith(`${root}?`));
    const target = fromList ? saved : { path: root, canvasId, offset: 24 };
    navigate(target.path, { state: { canvasListReturn: target } });
  }, [canvasId, navigate, preview, state]);
}
